// extracted by mini-css-extract-plugin
export default {"ctn":"smart_ctn__Tfxur","imgBox1":"smart_imgBox1__E+9YE","textBox":"smart_textBox__NlRsp","imgBox2":"smart_imgBox2__bvm8q","imgBox3":"smart_imgBox3__YdKbj"};